import React, { useEffect, useRef, useState } from "react";
import "./styles.scss";

import { trackEvent } from "../../helpers/analytics";
import FallbackImgSrc from "./assets/fallback-trustpilot-score.svg";

interface ILoadedImages {
  logo: boolean;
  stars: boolean;
  score: boolean ;
}

const MS_LOADING_FALLBACK = 3000;

export const TrustpilotScore: React.FC<React.HTMLAttributes<HTMLDivElement>> = (
  props,
) => {
  const [hasError, setHasError] = useState<boolean>(false);
  const logoRef = useRef<HTMLImageElement>(null);
  const starRef = useRef<HTMLImageElement>(null);
  const scoreRef = useRef<HTMLImageElement>(null);

  const checkLoadingImages = () => {
    const currentStatusOfLoadingImages = {
      logo: !logoRef.current?.complete,
      stars: !starRef.current?.complete,
      score: !scoreRef.current?.complete,
    };

    if (Object.values(currentStatusOfLoadingImages).includes(true)) {
      setHasError(true);

      Object.keys(currentStatusOfLoadingImages).forEach((image: string) => {
        if (currentStatusOfLoadingImages[image as keyof ILoadedImages]) {
          trackEvent("Not loaded trustpilot on time", {
            module: "Hero4",
            element_type: "Image",
            section: "Trustpilot",
            image,
          });
        }
      });
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      checkLoadingImages();
    }, MS_LOADING_FALLBACK);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const handleError = (image: string) => {
    setHasError(true);

    trackEvent("Failed to load trustpilot", {
      module: "Hero4",
      element_type: "Image",
      section: "Trustpilot",
      image,
    });
  };

  return (
    <div data-testid="trustpilot-score" className="hero4__bits__trustpilot">
      {hasError ? (
        <img src={FallbackImgSrc} alt="Trustpilot Score placeholder" />
      ) : (
        <div {...props}>
          <img
            ref={logoRef}
            src="https://emailsignature.trustpilot.com/brand/n/2/logo.png"
            height="24"
            width="97"
            alt="Trustpilot Logo"
            className="hero4__bits__trustpilot__logo"
            onError={() => handleError("logo")}
          />
          <img
            ref={starRef}
            src="https://emailsignature.trustpilot.com/newsletter/en-US/2/6392287740b116458553ed83/stars.png"
            height="24"
            width="128"
            alt="Trustpilot Stars"
            className="hero4__bits__trustpilot__stars"
            onError={() => handleError("stars")}
          />
          <img
            ref={scoreRef}
            src="https://emailsignature.trustpilot.com/newsletter/en-US/1/6392287740b116458553ed83/text2@2x.png"
            height="14"
            width="122"
            alt="Trustpilot Score"
            className="hero4__bits__trustpilot__score"
            onError={() => handleError("score")}
          />
        </div>
      )}
    </div>
  );
};
